"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
require("dragula/dist/dragula.css");
var lodash_1 = require("lodash");
var ng2_dragula_1 = require("ng2-dragula");
var empty_1 = require("rxjs/observable/empty");
var zip_1 = require("rxjs/observable/zip");
var operators_1 = require("rxjs/operators");
var takeUntil_1 = require("rxjs/operators/takeUntil");
var card_type_model_1 = require("../../../layout-models/card-type.model");
var designer_layout_model_1 = require("../../../layout-models/designer-layout.model");
var plugged_control_1 = require("../../../layout-models/form-models/plugged-control");
var model_converter_service_1 = require("../../../model-converter/model-converter.service");
var form_card_settings_component_1 = require("../../../settings/form-card-settings.component");
var form_control_central_settings_1 = require("../../../settings/form-control-central.settings");
var form_control_settings_component_1 = require("../../../settings/form-control-settings.component");
var form_runtime_component_loader_service_1 = require("../../../shared/form-runtime-component-loader.service");
var abstract_destruction_subject_1 = require("../../../utils/abstract-destruction-subject");
var dragula_dom_element_info_1 = require("../../../utils/dragula-dom-element.info");
var form_element_factory_1 = require("../../../utils/form-element.factory");
var initial_control_template_generator_1 = require("../../../utils/initial-control-template-generator");
var layout_utils_1 = require("../../../utils/layout-utils");
var controller_drop_location_enum_1 = require("./controller-drop-location.enum");
require("./form-designer.component.scss");
var form_designer_constants_1 = require("./form-designer.constants");
var form_dragula_options_1 = require("./form-dragula-options");
var layout_tabs_component_1 = require("./layout-tabs.component");
var form_settings_model_1 = require("./panel/form-settings.model");
var sub_form_settings_model_1 = require("./panel/sub-form-settings.model");
var workflow_form_settings_model_1 = require("./panel/workflow-form-settings.model");
var idm_document_service_client_js_1 = require("@synisys/idm-document-service-client-js");
var noop_1 = require("rxjs/util/noop");
var FormDesignerComponent = /** @class */ (function (_super) {
    __extends(FormDesignerComponent, _super);
    function FormDesignerComponent(dragulaService, activatedRoute, currentLanguageProvider, languageService, router, formReadingService, formWritingService, modelConverterService, formService, communicationService, location, runtimeComponentLoaderService, documentService, messageService) {
        var _this = _super.call(this) || this;
        _this.dragulaService = dragulaService;
        _this.activatedRoute = activatedRoute;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.languageService = languageService;
        _this.router = router;
        _this.formReadingService = formReadingService;
        _this.formWritingService = formWritingService;
        _this.modelConverterService = modelConverterService;
        _this.formService = formService;
        _this.communicationService = communicationService;
        _this.location = location;
        _this.runtimeComponentLoaderService = runtimeComponentLoaderService;
        _this.documentService = documentService;
        _this.messageService = messageService;
        _this.layout = new designer_layout_model_1.DesignerLayoutModel();
        _this.isReady = false;
        _this.initialized = false;
        _this.isCardSettingsActive = false;
        _this.isControlSettingsActive = false;
        _this.isControlCentralSettingsActive = false;
        _this.resizing = false;
        _this.formSettings = new form_settings_model_1.FormSettingsModel();
        _this.isHeaderExists = false;
        _this.isTabBarExists = false;
        _this.isDragging = false;
        _this.tabDragging = false;
        _this.headerDragging = false;
        _this.headersList = [];
        _this.showTrashBin = false;
        _this.showHeaderTrashBin = false;
        _this.showCardTrashBin = false;
        _this.itemInTrash = false;
        _this.controllerDropLocation = controller_drop_location_enum_1.ControllerDropLocation;
        _this.layoutCards = [];
        _this.cardUpperRowModels = new Map();
        _this.rowBagModels = new Map();
        _this.lowerRowBagModels = new Map();
        _this.nestedCardUpperRowModels = new Map();
        _this.nestedRowBagModels = new Map();
        _this.nestedLowerRowBagModels = new Map();
        _this.trashModels = [];
        _this.trashHeaderModels = [];
        _this.tabModels = [];
        _this.headerModels = [];
        _this.scrollModels = [];
        _this.trashCardModels = [];
        _this.dragulaOptions = new form_dragula_options_1.FormDragulaOptions();
        _this.isSubwayMapExists = false;
        _this.subwayMapDragging = false;
        _this.subwayMapList = [];
        _this.showSubwayMapTrashBin = false;
        _this.trashSubwayMapModels = [];
        _this.subwayMapModels = [];
        _this.elementFactory = new form_element_factory_1.FormElementFactory();
        _this.dragulaService.setOptions('fields-bag', _this.dragulaOptions.FIELDS_BAG_OPTIONS);
        return _this;
    }
    FormDesignerComponent_1 = FormDesignerComponent;
    Object.defineProperty(FormDesignerComponent.prototype, "formControlSettingsComponent", {
        get: function () {
            return this._formControlSettingsComponent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormDesignerComponent.prototype, "formCardSettingsComponent", {
        get: function () {
            return this._formCardSettingsComponent;
        },
        enumerable: true,
        configurable: true
    });
    FormDesignerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isExportable = this.router.url.includes('exportable');
        this.initDragulaOptions();
        this.initCommunicationService();
        var languages$ = this.languageService.getAvailableLanguages();
        var currentLanguage$ = this.currentLanguageProvider.getCurrentLanguage();
        zip_1.zip(languages$, currentLanguage$)
            .pipe(takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.languages = data[0];
            _this.currentLanguage = data[1];
            _this.prepareDesigner();
        }, function (error) { return console.error(error); });
    };
    FormDesignerComponent.prototype.getColumnSize = function (cell) {
        if (cell && cell.columnCount) {
            var size = (cell.columnCount / 12) * 100;
            if (size <= 0) {
                size = 1;
            }
            else if (size >= 100) {
                size = 100;
            }
            return size;
        }
    };
    FormDesignerComponent.prototype.getColumnCount = function (controller) {
        return controller.columnCount;
    };
    FormDesignerComponent.prototype.openCardSettings = function (card) {
        this.currentCard = card;
        this.checkAndGetMultiLingualCardTitle();
        this.isCardSettingsActive = true;
    };
    FormDesignerComponent.prototype.openControlSettings = function (controllerModel, card, rowId, isHeaderSettings) {
        if (isHeaderSettings === void 0) { isHeaderSettings = false; }
        if (this.isCardSettingsActive) {
            this._formCardSettingsComponent.close();
        }
        if (this.isControlSettingsActive) {
            this._formControlSettingsComponent.close();
        }
        if (controllerModel.isConfigurable && !this.isControlSettingsActive) {
            this._formControlSettingsComponent.initSettings(controllerModel, this.categoryName, this.languages, this.currentLanguage, this.formType, isHeaderSettings, this.parentCategoryName, this.layout.formEntityType === idm_dynamic_layout_interpreter_1.FormEntityType.SUB_FORM);
            var id = controllerModel.id;
            this.isControlSettingsActive = true;
            this.currentController = controllerModel;
            this.currentRowId = rowId;
            if (controllerModel.meta.settings.central) {
                this.openCentralSettings(controllerModel, card, rowId);
            }
        }
    };
    FormDesignerComponent.prototype.openHeaderSettings = function () {
        if (this.layout.header && this.formType === idm_dynamic_layout_interpreter_1.FormType.VIEW) {
            this.openControlSettings(this.layout.header, undefined, undefined, true);
        }
    };
    FormDesignerComponent.prototype.openCentralSettings = function (controllerModel, card, rowId) {
        this.currentFormControlCentralSettings = this.formControlCentralSettings.find(function (item) { return item.controllerModel.id === controllerModel.id; });
        this.currentFormControlCentralSettings.initSettings(controllerModel, this.categoryName, this.languages, this.currentLanguage);
        var containerIndex = this.getViewContainerIndex(card.id, rowId, controllerModel);
        this.currentViewContainerRef = this.viewContainerRefs.find(function (viewRef, index) {
            return containerIndex === index;
        });
        this.isControlCentralSettingsActive = true;
        this.cardWithOpenedCentralSettings = card;
        this.currentViewContainerRef.remove();
    };
    FormDesignerComponent.prototype.resizeClickEvent = function (event, cell, parentColumnCount) {
        this.containerWidth = this.cardContainer.nativeElement.offsetWidth - 40;
        this.resizing = true;
        this.resizedCell = cell;
        this.xBeforeResizing = event.clientX;
        this.parentColumnCount = parentColumnCount;
        event.preventDefault();
        event.stopPropagation();
    };
    FormDesignerComponent.prototype.resizeEvent = function (event) {
        if (this.resizing && this.resizedCell) {
            var colSize = this.containerWidth / 12;
            var diff = void 0;
            diff =
                (12 / this.parentColumnCount) *
                    (event.clientX - this.xBeforeResizing);
            var columns = diff / colSize;
            if (this.documentIsRightToLeft) {
                if (this.resizedCell.columnCount - columns >= 1) {
                    this.resizedCell.columnCount -= columns;
                }
                else {
                    this.resizedCell.columnCount = 1;
                }
            }
            else {
                this.resizedCell.columnCount += columns;
            }
        }
        this.xBeforeResizing = event.clientX;
    };
    FormDesignerComponent.prototype.releaseResize = function (event) {
        this.resizing = false;
        if (this.resizedCell) {
            var expectedSize = Math.round(this.resizedCell.columnCount);
            if (expectedSize >= 1) {
                this.resizedCell.columnCount = expectedSize;
            }
            else {
                this.resizedCell.columnCount = 1;
            }
        }
        this.resizedCell = undefined;
    };
    FormDesignerComponent.prototype.cardSettingsClose = function () {
        this.isCardSettingsActive = false;
        if (this.isControlCentralSettingsActive) {
            this.initController(this.currentViewContainerRef, this.currentController);
            this.currentFormControlCentralSettings.cleanup();
            this.isControlCentralSettingsActive = false;
            this.isControlSettingsActive = false;
        }
        this.currentCard = undefined;
        this.cardWithOpenedCentralSettings = undefined;
    };
    FormDesignerComponent.prototype.onControlSettingsClose = function () {
        this.isControlSettingsActive = false;
        this.currentRowId = undefined;
        if (this.currentController.meta.settings.central) {
            this.initController(this.currentViewContainerRef, this.currentController);
            this.currentFormControlCentralSettings.cleanup();
            this.isControlCentralSettingsActive = false;
            this.cardWithOpenedCentralSettings = null;
        }
    };
    FormDesignerComponent.prototype.closeSettingsOnAwayClick = function () {
        this.onControlSettingsClose();
        this._formControlSettingsComponent.cleanup();
    };
    FormDesignerComponent.prototype.export = function () {
        var _this = this;
        if (this.layout.header) {
            Object.assign(this.layout.header.state, this.formSettings.toJS());
            this.confirmSettingsTempDocuments();
        }
        if (!this.tabsComponent.tabBarExists) {
            this.layout.setNonTabularContent(this.layoutContent);
        }
        else {
            this.layout.setTabularContent(this.tabsComponent.tabs);
        }
        this.modelConverterService
            .fromDesignerLayoutToFormDomain(this.layout, this.categoryName, this.formName, this.parentCategoryName, this.formType)
            .pipe(operators_1.switchMap(function (model) {
            _this.loadedFormDto.model = model;
            _this.loadedFormDto.description = _this.formSettings.getDescriptionObject();
            _this.loadedFormDto.name = _this.formSettings.getNameObject();
            return _this.formService.fullUpdateForm(_this.loadedFormDto);
        }), operators_1.catchError(function (error) {
            console.error(error);
            return empty_1.empty();
        }), takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (response) {
            _this.location.back();
        }, console.error);
    };
    FormDesignerComponent.prototype.cancelAction = function () {
        this.location.back();
        // this.router.navigate(['configurations/forms']);
    };
    FormDesignerComponent.prototype.drawController = function (rowWhereControllerDropped, fieldControllerModel, cardId) {
        var _this = this;
        setTimeout(function () {
            var containerIndex = _this.getViewContainerIndex(cardId, rowWhereControllerDropped, fieldControllerModel);
            var viewContainer = _this.viewContainerRefs.find(function (viewRef, index) {
                return containerIndex === index;
            });
            _this.initController(viewContainer, fieldControllerModel);
        }, 20);
    };
    FormDesignerComponent.prototype.drawControllerInNestedCard = function (cardId, rowId, nestedCardId, nestedRowId, fieldControllerModel) {
        var _this = this;
        setTimeout(function () {
            var containerIndex = _this.getNestedViewContainerIndexToDrop(cardId, rowId, nestedCardId, nestedRowId, fieldControllerModel);
            var viewContainer = _this.nestedViewContainerRefs.find(function (viewRef, index) {
                return containerIndex === index;
            });
            _this.initController(viewContainer, fieldControllerModel);
        }, 20);
    };
    FormDesignerComponent.prototype.ngAfterViewInit = function () {
        this.documentIsRightToLeft = document.dir === 'rtl';
        this.initialized = true;
    };
    FormDesignerComponent.prototype.initHeaderControllerOnDrop = function (headerController) {
        Object.assign(headerController.state, this.formSettings.toJS());
        this.initHeaderControl(headerController);
    };
    FormDesignerComponent.prototype.initFormSettings = function (layoutModel) {
        if (layoutModel && layoutModel.header && layoutModel.header.state) {
            this.formSettings.fromJS(layoutModel.header.state, this.messageService);
        }
        this.formSettings.initFormDataRelatedSettings(this.loadedFormDto);
    };
    FormDesignerComponent.prototype.drawControllers = function () {
        var _this = this;
        this.layoutContent.layoutRows.map(function (row) {
            row.cards.map(function (card) {
                var cardType = new card_type_model_1.CardTypeModel('Card', 'de.form_builder.card');
                cardType.checkedInLayout = true;
                cardType.card = card;
                cardType.rowId = row.id;
                _this.layoutCards.push(cardType);
                _this.fillDesignerCardWithControls(card);
                card.formCardRows.map(function (controllerRow) {
                    controllerRow.cells.map(function (cell, index) {
                        if (cell.isController()) {
                            _this.drawController(controllerRow.rowId, cell.controller, card.id);
                        }
                        if (cell.isCard()) {
                            _this.fillDesignerNestedCardWithControls(cell.card);
                            _this.drawControllersOfNestedCard(card.id, controllerRow.rowId, cell.card);
                        }
                    });
                });
            });
        });
    };
    FormDesignerComponent.prototype.drawControllersOfNestedCard = function (cardId, rowId, nestedCard) {
        var _this = this;
        nestedCard.formCardRows.forEach(function (row) {
            row.cells.forEach(function (cell) {
                if (cell.isController()) {
                    _this.drawControllerInNestedCard(cardId, rowId, nestedCard.id, row.rowId, cell.controller);
                }
            });
        });
    };
    FormDesignerComponent.prototype.getTooltipSettingsFrom = function (controller) {
        if (controller &&
            controller.state &&
            controller.state['tooltipSettings']) {
            return idm_ng_controls_1.TooltipSettings.fromJsonString(controller.state['tooltipSettings']);
        }
        return undefined;
    };
    FormDesignerComponent.prototype.cancelDragging = function (bagName) {
        this.dragulaService.find(bagName).drake.cancel(true);
    };
    FormDesignerComponent.prototype.closeSettingsIfOpen = function (id, isCard) {
        if (isCard) {
            if (this._formCardSettingsComponent &&
                this._formCardSettingsComponent.card &&
                this._formCardSettingsComponent.card.id === id) {
                this._formCardSettingsComponent.close();
            }
        }
        else {
            if (this._formControlSettingsComponent &&
                this._formControlSettingsComponent.controllerModel &&
                this._formControlSettingsComponent.controllerModel.id === id) {
                this._formControlSettingsComponent.close();
            }
        }
    };
    FormDesignerComponent.prototype.formEntityType = function () {
        return this.loadedFormDto.formEntityTypeId;
    };
    FormDesignerComponent.prototype.getTitleSrcFrom = function (cell) {
        if (lodash_1.isNil(cell.controller.title) &&
            !lodash_1.isNil(cell.controller.singleFieldMultilingualDisplayName)) {
            return 'display_name';
        }
        else if (lodash_1.isNil(cell.controller.title) &&
            lodash_1.isNil(cell.controller.singleFieldMultilingualDisplayName)) {
            return 'msg';
        }
        else {
            return cell.controller.title.titleMessageSource;
        }
    };
    FormDesignerComponent.prototype.tabBarRemoveAction = function (lastedTab) {
        this.cardUpperRowModels = new Map();
        this.rowBagModels = new Map();
        this.lowerRowBagModels = new Map();
        this.layoutCards = [];
        this.layoutContent = lastedTab.tabLayout;
        this.drawControllers();
        this.isTabBarExists = false;
    };
    FormDesignerComponent.prototype.tabSelect = function (tab) {
        this.cardUpperRowModels = new Map();
        this.rowBagModels = new Map();
        this.lowerRowBagModels = new Map();
        this.layoutCards = [];
        this.layoutContent = tab.tabLayout;
        this.drawControllers();
    };
    FormDesignerComponent.prototype.trackByRowsIds = function (index, row) {
        return row.id;
    };
    FormDesignerComponent.prototype.trackByCardsIds = function (index, card) {
        return card.id;
    };
    FormDesignerComponent.prototype.trackByFormCardRowsIds = function (index, formCardRow) {
        return formCardRow.rowId;
    };
    FormDesignerComponent.prototype.trackByFormCardCellsIds = function (index, formCardCell) {
        return formCardCell.id;
    };
    FormDesignerComponent.prototype.initSubwayMapControl = function (subwayMapController) {
        var _this = this;
        this.layout.subwayMap = subwayMapController;
        this.subwayMapList.push({});
        setTimeout(function () {
            _this.initController(_this.subwayMapControllerContainer.first, subwayMapController);
            _this.isSubwayMapExists = true;
        }, 10);
    };
    FormDesignerComponent.prototype.idByFields = function (controller) {
        if (lodash_1.isNil(controller) || lodash_1.isNil(controller.fields)) {
            return '';
        }
        return lodash_1.values(controller.fields)
            .filter(skynet_store_utilities_1.notNil)
            .map(function (field) { return field.metaFieldId.systemName; })
            .join('-');
    };
    FormDesignerComponent.prototype.isLayoutEmpty = function () {
        return (this.layoutContent &&
            this.layoutContent.isEmpty() &&
            !this.isHeaderExists &&
            !this.isSubwayMapExists);
    };
    FormDesignerComponent.prototype.isCardEmpty = function (card) {
        return (card.formCardRows.length === 0 ||
            card.formCardRows.every(function (row) { return row.cells.length === 0; }));
    };
    FormDesignerComponent.prototype.labelNotEmpty = function (cell) {
        if (cell.controller.title &&
            cell.controller.title.titleMessageSource === 'custom') {
            return !lodash_1.isEmpty(cell.controller.title.customText[this.currentLanguage.getId()]);
        }
        return true;
    };
    FormDesignerComponent.prototype.fillDesignerCardWithControls = function (card) {
        var _this = this;
        card.formCardRows.map(function (row) {
            var rowControls = [];
            row.cells.map(function (cell, index) {
                if (cell.isController()) {
                    var control = new plugged_control_1.PluggedControl(cell.controller.meta);
                    control.checkedInLayout = true;
                    control.id = cell.controller.id;
                    rowControls.push(control);
                }
                if (cell.isCard()) {
                    var nestedCardType = new card_type_model_1.CardTypeModel('Nested Card', 'de.form_builder.nested_card');
                    nestedCardType.card = cell.card;
                    nestedCardType.checkedInLayout = true;
                    rowControls.push(nestedCardType);
                }
            });
            _this.rowBagModels.set(row.rowId, rowControls);
            _this.lowerRowBagModels.set(row.rowId, []);
        });
        this.cardUpperRowModels.set(card.id, []);
    };
    FormDesignerComponent.prototype.fillDesignerNestedCardWithControls = function (nestedCard) {
        var _this = this;
        nestedCard.formCardRows.map(function (row) {
            var rowControls = [];
            row.cells.map(function (cell, index) {
                if (cell.isController()) {
                    var control = new plugged_control_1.PluggedControl(cell.controller.meta);
                    control.checkedInLayout = true;
                    control.id = cell.controller.id;
                    rowControls.push(control);
                }
                // todo
            });
            _this.nestedRowBagModels.set(row.rowId, rowControls);
            _this.nestedLowerRowBagModels.set(row.rowId, []);
        });
        this.nestedCardUpperRowModels.set(nestedCard.id, []);
    };
    FormDesignerComponent.prototype.initHeaderControl = function (headerController) {
        var _this = this;
        this.layout.header = headerController;
        this.headersList.push({});
        setTimeout(function () {
            _this.initController(_this.headerControllerContainer.first, headerController);
            _this.isHeaderExists = true;
        }, 10);
    };
    FormDesignerComponent.prototype.initCommunicationService = function () {
        var _this = this;
        this.communicationService.parentObservable
            .pipe(operators_1.filter(function (data) {
            return data.key === idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED;
        }), operators_1.map(lodash_1.cloneDeep), // bug with data references
        operators_1.distinctUntilChanged(lodash_1.isEqual), takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            if (data.data['state'] ||
                data.data['bindings'] ||
                data.data['fields'] ||
                data.data['controlLabel']) {
                if (data.data.hasOwnProperty('fields')) {
                    _this.currentController.addMapFields(data.data['fields']);
                }
                _this.currentController.bindings = __assign({}, _this.currentController.bindings, data.data['bindings']);
                _this.currentController.actions = __assign({}, _this.currentController.actions, data.data['actions']);
                var resultState = __assign({}, _this.currentController.state, data.data['state']);
                var excludedFieldKeys = [];
                for (var _i = 0, _a = Object.keys(_this.currentController.fields); _i < _a.length; _i++) {
                    var key = _a[_i];
                    excludedFieldKeys.push(key + "-name");
                    excludedFieldKeys.push(key);
                    excludedFieldKeys.push(key + "-id");
                    excludedFieldKeys.push(key + "-category");
                }
                _this.currentController.state = lodash_1.omit(resultState, lodash_1.keys(_this.currentController.bindings).concat(lodash_1.keys(_this.currentController.actions), excludedFieldKeys));
                if (data.data['controlLabel']) {
                    _this.currentController.title = idm_dynamic_layout_interpreter_1.TitleModel.fromJSON(data.data['controlLabel']);
                }
            }
        }, console.error);
    };
    FormDesignerComponent.prototype.getViewContainerIndex = function (cardId, rowWhereControllerDropped, droppedFieldControllerModel) {
        var viewContainerIndex = 0;
        var indexOfCard;
        var cardToDropIn;
        this.layoutCards.map(function (card, index) {
            if (card.card.id === cardId) {
                indexOfCard = index;
                cardToDropIn = card.card;
            }
        });
        for (var i = 0; i < indexOfCard; i++) {
            for (var j = 0; j < this.layoutCards[i].card.formCardRows.length; j++) {
                viewContainerIndex += this.layoutCards[i].card.formCardRows[j]
                    .cells.length;
            }
        }
        for (var i = 0; i < cardToDropIn.formCardRows.length; i++) {
            if (cardToDropIn.formCardRows[i].rowId === rowWhereControllerDropped) {
                for (var j = 0; j < cardToDropIn.formCardRows[i].cells.length; j++) {
                    if (cardToDropIn.formCardRows[i].cells[j].id ===
                        droppedFieldControllerModel.id) {
                        viewContainerIndex += j;
                        break;
                    }
                }
                break;
            }
            viewContainerIndex += cardToDropIn.formCardRows[i].cells.length;
        }
        return viewContainerIndex;
    };
    FormDesignerComponent.prototype.getNestedViewContainerIndexToDrop = function (cardId, rowId, nestedCardId, nestedRowId, fieldControllerModel) {
        var viewContainerIndex = 0;
        var indexOfCard;
        var cardToDropIn;
        this.layoutCards.map(function (card, index) {
            if (card.card.id === cardId) {
                indexOfCard = index;
                cardToDropIn = card.card;
            }
        });
        for (var i = 0; i < indexOfCard; i++) {
            for (var j = 0; j < this.layoutCards[i].card.formCardRows.length; j++) {
                for (var _i = 0, _a = this.layoutCards[i].card.formCardRows[j]
                    .cells; _i < _a.length; _i++) {
                    var formCard = _a[_i];
                    if (formCard.isCard()) {
                        formCard.card.formCardRows.forEach(function (row) {
                            viewContainerIndex += row.cells.length;
                        });
                    }
                }
            }
        }
        var indexOfCardRow = cardToDropIn.formCardRows.findIndex(function (row) { return row.rowId === rowId; });
        for (var i = 0; i < indexOfCardRow; i++) {
            for (var _b = 0, _c = cardToDropIn.formCardRows[i].cells; _b < _c.length; _b++) {
                var cell = _c[_b];
                if (cell.isCard()) {
                    cell.card.formCardRows.forEach(function (row) {
                        viewContainerIndex += row.cells.length;
                    });
                }
            }
        }
        var indexOfNestedCard = cardToDropIn.formCardRows[indexOfCardRow].cells.findIndex(function (cell) { return cell.id === nestedCardId; });
        for (var i = 0; i < indexOfNestedCard; i++) {
            var cell = cardToDropIn.formCardRows[indexOfCardRow].cells[i];
            if (cell.isCard()) {
                cell.card.formCardRows.forEach(function (row) {
                    viewContainerIndex += row.cells.length;
                });
            }
        }
        var nestedCard = cardToDropIn.formCardRows[indexOfCardRow].cells[indexOfNestedCard]
            .card;
        var indexOfNestedRow = nestedCard.formCardRows.findIndex(function (nestedRow) { return nestedRow.rowId === nestedRowId; });
        for (var i = 0; i < indexOfNestedRow; i++) {
            viewContainerIndex += nestedCard.formCardRows[i].cells.length;
        }
        for (var i = 0; i < nestedCard.formCardRows.length; i++) {
            if (nestedCard.formCardRows[i].rowId === nestedRowId) {
                for (var j = 0; j < nestedCard.formCardRows[i].cells.length; j++) {
                    if (nestedCard.formCardRows[i].cells[j].id ===
                        fieldControllerModel.id) {
                        viewContainerIndex += j;
                        break;
                    }
                }
                break;
            }
        }
        return viewContainerIndex;
    };
    FormDesignerComponent.prototype.initDragula = function () {
        var _this = this;
        this.dragulaService.dropModel
            .pipe(operators_1.filter(function (value) {
            return ([
                'fields-bag',
                'card-type-bag',
                'headers-type-bag',
                'subwaymap-type-bag',
                'tabs-type-bag',
            ].indexOf(value[0]) >= 0);
        }), takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (value) {
            var designerElement = _this.elementFactory.create(new dragula_dom_element_info_1.DragulaDomElementInfo(value));
            designerElement.onDrop(_this);
        }, console.error);
        this.dragulaService.over
            .pipe(operators_1.filter(function (value) {
            return ([
                'fields-bag',
                'card-type-bag',
                'headers-type-bag',
                'subwaymap-type-bag',
                'tabs-type-bag',
            ].indexOf(value[0]) >= 0);
        }), takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (value) {
            var designerElement = _this.elementFactory.create(new dragula_dom_element_info_1.DragulaDomElementInfo(value));
            designerElement.onHover(_this);
        }, console.error);
        this.dragulaService.drag
            .pipe(operators_1.filter(function (value) {
            return ([
                'fields-bag',
                'card-type-bag',
                'headers-type-bag',
                'subwaymap-type-bag',
                'tabs-type-bag',
            ].indexOf(value[0]) >= 0);
        }), takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (value) {
            var designerElement = _this.elementFactory.create(new dragula_dom_element_info_1.DragulaDomElementInfo(value));
            designerElement.onDrag(_this);
        }, console.error);
        this.dragulaService.cloned
            .pipe(operators_1.filter(function (value) {
            return ([
                'fields-bag',
                'card-type-bag',
                'headers-type-bag',
                'subwaymap-type-bag',
                'tabs-type-bag',
            ].indexOf(value[0]) >= 0);
        }), takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (value) {
            var domInfo = new dragula_dom_element_info_1.DragulaDomElementInfo(value);
            _this.newCreatedRowId = undefined;
            domInfo.addDisplayInlineToElem();
            var designerElement = _this.elementFactory.create(domInfo);
            designerElement.onClone(_this);
        }, console.error);
        this.dragulaService.out
            .pipe(operators_1.filter(function (value) {
            return ([
                'fields-bag',
                'card-type-bag',
                'headers-type-bag',
                'subwaymap-type-bag',
                'tabs-type-bag',
            ].indexOf(value[0]) >= 0);
        }), takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (value) {
            layout_utils_1.LayoutUtils.stopScrolling(_this);
        }, console.error);
        this.dragulaService.dragend
            .pipe(operators_1.filter(function (value) {
            return ([
                'fields-bag',
                'card-type-bag',
                'headers-type-bag',
                'subwaymap-type-bag',
                'tabs-type-bag',
            ].indexOf(value[0]) >= 0);
        }), takeUntil_1.takeUntil(this.destroySubject$))
            .subscribe(function (value) {
            _this.hoveredRowId = undefined;
            _this.newControllerDragLocation = undefined;
            _this.beforeHoveredRowId = undefined;
            _this.afterHoveredRowId = undefined;
            _this.isDragging = false;
            _this.showTrashBin = false;
            _this.showCardTrashBin = false;
            _this.showHeaderTrashBin = false;
            _this.showSubwayMapTrashBin = false;
            _this.itemInTrash = false;
            _this.tabDragging = false;
            _this.headerDragging = false;
            _this.subwayMapDragging = false;
        }, console.error);
    };
    FormDesignerComponent.prototype.prepareDesigner = function () {
        var _this = this;
        if (this.formId) {
            this.loadDesignerContent();
        }
        else {
            this.activatedRoute.params
                .pipe(takeUntil_1.takeUntil(this.destroySubject$))
                .subscribe(function (params) {
                _this.formId = params['formId'];
                _this.loadDesignerContent();
            }, function (error) { return console.error(error); });
        }
    };
    FormDesignerComponent.prototype.loadDesignerContent = function () {
        var _this = this;
        if (this.formId) {
            this.formService
                .loadForm(this.formName, this.formId, this.categoryName)
                .subscribe(function (form) {
                _this.processFormData(form);
                _this.initDragula();
                _this.drawControllers();
                _this.isReady = true;
            }, function (error) { return console.error(error); });
        }
        else {
            this.layoutContent = this.layout.content;
            this.initDragula();
            this.isReady = true;
        }
    };
    FormDesignerComponent.prototype.processFormData = function (form) {
        this.formType = form.type;
        this.categoryName = form.model.category;
        this.formName = form.model.formName;
        this.loadedFormDto = form;
        // let designerContentLayoutModel: DesignerLayoutModel;
        if (form.model.content) {
            this.layout = this.modelConverterService.fromDomainToFormDesignerLayout(form.model);
        }
        else {
            this.layout = new designer_layout_model_1.DesignerLayoutModel();
        }
        if (this.layout.content.isWithTabs()) {
            this.tabsComponent.tabEditMode(this.layout.content.tabs);
            this.layoutContent = this.tabsComponent.currentTab.tabLayout;
            this.isTabBarExists = true;
        }
        else {
            this.layoutContent = this.layout.content;
            if (this.layoutContent.isEmpty()) {
                this.layoutContent.makeEmptyContent();
            }
        }
        this.initSettings(form);
        this.initFormSettings(this.layout);
        if (this.layout.header) {
            this.initHeaderControl(this.layout.header);
            this.headerModels.push(this.layout.header.meta);
        }
        if (this.layout.subwayMap) {
            this.initSubwayMapControl(this.layout.subwayMap);
            this.subwayMapModels.push(this.layout.subwayMap.meta);
        }
    };
    FormDesignerComponent.prototype.initSettings = function (form) {
        switch (this.formEntityType()) {
            case idm_dynamic_layout_interpreter_1.FormEntityType.SUB_FORM:
                this.layout.formEntityType = idm_dynamic_layout_interpreter_1.FormEntityType.SUB_FORM;
                this.parentCategoryName = form.categorySystemName;
                if (lodash_1.isNil(this.layoutContent.subFormSettings)) {
                    this.layoutContent.subFormSettings = sub_form_settings_model_1.SubFormSettingsModel.initialSettings(this.languages);
                }
                this.subFormSettings = this.layoutContent.subFormSettings;
                break;
            case idm_dynamic_layout_interpreter_1.FormEntityType.WORKFLOW_FORM:
                this.layout.formEntityType = idm_dynamic_layout_interpreter_1.FormEntityType.WORKFLOW_FORM;
                if (lodash_1.isNil(this.layoutContent.workflowFormSettings)) {
                    this.layoutContent.workflowFormSettings = workflow_form_settings_model_1.initialWorkflowFormSettingsModel(this.languages);
                }
                this.workflowFormSettings = this.layoutContent.workflowFormSettings;
        }
    };
    FormDesignerComponent.prototype.initController = function (container, controller) {
        var contextMapping = new Map();
        contextMapping.set('controller', controller);
        contextMapping.set('category', this.categoryName);
        contextMapping.set('id', controller.id);
        this.runtimeComponentLoaderService.initComponent(container, controller.meta.selector, contextMapping, initial_control_template_generator_1.InitialControlTemplateGenerator.generateTemplate(controller, this.formType));
    };
    FormDesignerComponent.prototype.checkAndGetMultiLingualCardTitle = function () {
        if (!this.currentCard.isTitleDefined()) {
            var multilingualStringBuilder_1 = idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder();
            this.languages.forEach(function (language) {
                var languageId = language.getId();
                multilingualStringBuilder_1.withValueForLanguage(languageId, '');
            });
            this.currentCard.title = multilingualStringBuilder_1.build();
        }
    };
    FormDesignerComponent.prototype.initDragulaOptions = function () {
        var _designerInstance = this;
        this.optionsTab = {
            copy: function (el, source) {
                return source.id !== FormDesignerComponent_1.TABS_CONTAINER_DOM_ID;
            },
            accepts: function (el) {
                return !_designerInstance.tabsComponent.tabBarExists;
            },
            moves: function (el) {
                return !_designerInstance.tabsComponent.tabBarExists;
            },
        };
        this.optionsHeader = {
            copy: function (el, source) {
                return source.id !== form_designer_constants_1.FormDesignerConstants.HEADER_CONTAINER;
            },
            accepts: function (el, target, source) {
                return _designerInstance.headerModels.length === 0 ||
                    source.id === form_designer_constants_1.FormDesignerConstants.HEADER_CONTAINER;
            },
            moves: function (el, source) {
                return _designerInstance.headerModels.length === 0 ||
                    source.id === form_designer_constants_1.FormDesignerConstants.HEADER_CONTAINER;
            },
        };
        this.optionsSubwayMap = {
            copy: function (el, source) {
                return source.id !== form_designer_constants_1.FormDesignerConstants.SUBWAYMAP_CONTAINER;
            },
            accepts: function (el, target, source) {
                return _designerInstance.subwayMapModels.length === 0 ||
                    source.id === form_designer_constants_1.FormDesignerConstants.SUBWAYMAP_CONTAINER;
            },
            moves: function (el, source) {
                return _designerInstance.subwayMapModels.length === 0 ||
                    source.id === form_designer_constants_1.FormDesignerConstants.SUBWAYMAP_CONTAINER;
            },
        };
    };
    FormDesignerComponent.prototype.confirmSettingsTempDocuments = function () {
        var _this = this;
        var documentIdsPresent$ = this.formSettings.userHelpItems
            .filter(function (userHelpItem) {
            return userHelpItem.documentId &&
                userHelpItem.documentId !== -1;
        })
            .map(function (userHelpItem) {
            return _this.documentService
                .getIsDocumentPresent(userHelpItem.documentId)
                .pipe(operators_1.map(function (isPresent) { return ({
                isPresent: isPresent,
                documentId: userHelpItem.documentId,
            }); }));
        });
        if (documentIdsPresent$.length === 0) {
            return;
        }
        zip_1.zip.apply(void 0, documentIdsPresent$).pipe(operators_1.take(1), operators_1.mergeMap(function (documentIdsPresent) {
            var confirmUploads$ = documentIdsPresent
                .filter(function (documentIdPresent) {
                return !documentIdPresent.isPresent;
            })
                .map(function (documentIdPresent) {
                return _this.documentService.confirmUpload(documentIdPresent.documentId, _this.formId);
            });
            return confirmUploads$.length === 0
                ? empty_1.empty()
                : zip_1.zip.apply(void 0, confirmUploads$);
        }))
            .subscribe(noop_1.noop, console.error);
    };
    var FormDesignerComponent_1;
    FormDesignerComponent.TABS_CONTAINER_DOM_ID = 'tabs-container';
    FormDesignerComponent.HEADER_CONTAINER_DOM_ID = 'header-container';
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], FormDesignerComponent.prototype, "formId", void 0);
    __decorate([
        core_1.ViewChild('tabs', { read: layout_tabs_component_1.LayoutTabsComponent }),
        __metadata("design:type", layout_tabs_component_1.LayoutTabsComponent)
    ], FormDesignerComponent.prototype, "tabsComponent", void 0);
    __decorate([
        core_1.ViewChild('cardsContainer', { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], FormDesignerComponent.prototype, "cardContainer", void 0);
    __decorate([
        core_1.ViewChild('scrollElement', { read: core_1.ElementRef }),
        __metadata("design:type", core_1.ElementRef)
    ], FormDesignerComponent.prototype, "scrollElement", void 0);
    __decorate([
        core_1.ViewChildren('cardControllers', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.QueryList)
    ], FormDesignerComponent.prototype, "viewContainerRefs", void 0);
    __decorate([
        core_1.ViewChildren('nestedCardControllers', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.QueryList)
    ], FormDesignerComponent.prototype, "nestedViewContainerRefs", void 0);
    __decorate([
        core_1.ViewChild('formCardSettings', { read: form_card_settings_component_1.FormCardSettingsComponent }),
        __metadata("design:type", form_card_settings_component_1.FormCardSettingsComponent)
    ], FormDesignerComponent.prototype, "_formCardSettingsComponent", void 0);
    __decorate([
        core_1.ViewChild('formControlSettings', { read: form_control_settings_component_1.FormControlSettingsComponent }),
        __metadata("design:type", form_control_settings_component_1.FormControlSettingsComponent)
    ], FormDesignerComponent.prototype, "_formControlSettingsComponent", void 0);
    __decorate([
        core_1.ViewChildren('formCentralControlSettings', {
            read: form_control_central_settings_1.FormControlCentralSettings,
        }),
        __metadata("design:type", core_1.QueryList)
    ], FormDesignerComponent.prototype, "formControlCentralSettings", void 0);
    __decorate([
        core_1.ViewChildren('headerController', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.QueryList)
    ], FormDesignerComponent.prototype, "headerControllerContainer", void 0);
    __decorate([
        core_1.ViewChildren('subwayMapController', { read: core_1.ViewContainerRef }),
        __metadata("design:type", core_1.QueryList)
    ], FormDesignerComponent.prototype, "subwayMapControllerContainer", void 0);
    __decorate([
        core_1.HostListener('document:mousemove', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], FormDesignerComponent.prototype, "resizeEvent", null);
    __decorate([
        core_1.HostListener('document:mouseup', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [MouseEvent]),
        __metadata("design:returntype", void 0)
    ], FormDesignerComponent.prototype, "releaseResize", null);
    FormDesignerComponent = FormDesignerComponent_1 = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'form-designer',
            template: require('./form-designer.component.html'),
            encapsulation: core_1.ViewEncapsulation.None,
            providers: [ng2_dragula_1.DragulaService],
        }),
        __metadata("design:paramtypes", [ng2_dragula_1.DragulaService,
            router_1.ActivatedRoute,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_message_language_service_client_js_1.LanguageService,
            router_1.Router,
            idm_dynamic_layout_interpreter_1.LayoutReadingService,
            idm_dynamic_layout_interpreter_1.LayoutWritingService,
            model_converter_service_1.ModelConverterService,
            idm_dynamic_layout_interpreter_1.FormService,
            idm_dynamic_controls_metadata_1.CommunicationService,
            common_1.Location,
            form_runtime_component_loader_service_1.FormRuntimeComponentLoaderService,
            idm_document_service_client_js_1.DocumentService,
            idm_message_language_service_client_js_1.MessageService])
    ], FormDesignerComponent);
    return FormDesignerComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.FormDesignerComponent = FormDesignerComponent;
//# sourceMappingURL=form-designer.component.js.map